import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';

interface NoExistingPatientsFoundModalProps {
  id: string;
  isOpen: boolean;
  onCancel: () => void;
  onCreateNewProfile: () => void;
}

const modalArgs = {
  bodyStyle: {
    overflow: 'visible',
    padding: '18px 0',
  },
  footerStyle: {
    padding: '0px',
  },
  title: 'No existing patients found',
  titleStyle: {
    flex: '1 0 0',
    padding: '0px',
  },
};
const NoExistingPatientsFoundModal = ({
  id,
  isOpen,
  onCancel,
  onCreateNewProfile,
}: NoExistingPatientsFoundModalProps) => {
  const TOP_LEVEL_ID = `${id}__no-patients-found-modal`;
  const subTitle =
    'No patient profiles were found using the information provided.';
  return (
    <ModalV2
      footerContent={
        <ChakraFlex width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__create`}
            isFullWidth
            leftIcon={FAIconName.userPlusRegular}
            onClick={onCreateNewProfile}
            variant="primary"
          >
            Create new profile
          </FireflyButton>
        </ChakraFlex>
      }
      {...modalArgs}
      id={`${TOP_LEVEL_ID}__modal`}
      isOpen={isOpen}
      onClose={onCancel}
      size="lg"
    >
      <Text alignSelf="start" id={`${id}-subtitle`} variant="body">
        {subTitle}
      </Text>
    </ModalV2>
  );
};

export default NoExistingPatientsFoundModal;
